import React from 'react';
import {StorageKey} from "../../../enums/StorageKey";
import {t} from "@lingui/macro";
import {CreatedAtTd} from "../../Table/Common/CreatedAtTd";
import TransactionType from "../../TransactionType";
import dayjs from 'dayjs';
import Big from "big.js";
import FormatNumber from "../../FormatNumber";
import {DateTimeWidth} from "../../Table/Common/CommonWidths";
import { sortColumnByString } from '../sortColumnByString';

export function numberSorter(a, b) {
    if (a.number != null && b.number != null)
        return a.number.localeCompare(b.number);
    if (a.number) // b is missing
        return 1;
    if (b.number) // a is missing
        return -1;
    return 0;
}

export function amountSorter(amountA, amountB, sortOrder) {
    if (amountA !== null && amountB !== null) {
        if (amountA < amountB)
            return -1;
        if (amountA > amountB)
            return 1;
        return 0;
    }
    if (amountA === null)
        return sortOrder === 'ascend' ? 1 : -1;

    if (amountB === null)
        return sortOrder === 'ascend' ? -1 : 1;
    return null;
}

function getColumns(props = {}) {
    const { isNegated = false } = props;
    return [
        {
            title: t`No.`,
            dataIndex: 'number',
            key: 'number',
            width: 125,
            sorter: numberSorter,
            render: text => text || '-',
        },
        {
            title: t`Type`,
            dataIndex: 'type',
            key: 'type',
            width: 140,
            render: (text, record) => <TransactionType record={record} />,
        },
        {
            title: t`Date`,
            dataIndex: 'date',
            key: 'date',
            sorter: (a, b) => a.date.localeCompare(b.date),
            render: text => dayjs(text).format('DD/MM/YYYY'),
        },
        {
            title: t`Contact`,
            dataIndex: 'contact_name',
            key: 'name',
            sorter: (a, b) => sortColumnByString(a.contact_name, b.contact_name),
            // sorter: (a, b) => {
            //     if (a.contact_name != null && b.contact_name != null)
            //         return a.contact_name.localeCompare(b.contact_name);
            //     if (a.contact_name) // b is missing
            //         return 1;
            //     if (b.contact_name) // a is missing
            //         return -1;
            //     return 0;
            // },
            render: text => (
                <span>{text || '-'}</span>
            ),
        },
        {
            title: t`Reference No.`,
            dataIndex: 'number2',
            key: 'number2',
            ellipsis: true,
            sorter: (a, b) => sortColumnByString(a.number2, b.number2),
            render: text => <span>{text || '-'}</span>,
        },
        {
            title: t`Payment Method`,
            dataIndex: 'payment_method_name',
            key: 'payment_method_name',
            ellipsis: true,
            // sorter,
            width: 140,
            render: text => <span>{text || '-'}</span>,
        },
        {
            title: t`Description`,
            dataIndex: 'description',
            key: 'description',
            width: 150,
            // ellipsis:true,
            render: text => text || '-',
        },
        {
            title: t`Spent`,
            dataIndex: 'amount',
            key: 'debit',
            align: 'right',
            sorter: (a, b, sortOrder) => {
                const aAmt = !isNegated ? a.amount : -a.amount;
                const bAmt = !isNegated ? b.amount : -b.amount;
                const amountA = aAmt > 0 ? aAmt : null;
                const amountB = bAmt > 0 ? bAmt : null;
                return amountSorter(amountA, amountB, sortOrder);
            },
            render: text => {
                const amountB = new Big(text);
                if (!isNegated) {
                    if (amountB.lte(0)) return null;
                    return <FormatNumber amount={text} />;
                }
                if (amountB.gte(0))
                    return null;
                return <FormatNumber amount={-text} />;
            },
        },
        {
            title: t`Received`,
            dataIndex: 'amount',
            key: 'credit',
            align: 'right',
            sorter: (a, b, sortOrder) => {
                const aAmt = !isNegated ? -a.amount : a.amount;
                const bAmt = !isNegated ? -b.amount : b.amount;
                const amountA = aAmt < 0 ? null : aAmt;
                const amountB = bAmt < 0 ? null : bAmt;
                return amountSorter(amountA, amountB, sortOrder);
            },
            render: text => {
                const amountB = new Big(text);
                if (!isNegated) {
                    if (amountB.gte(0)) return null;
                    return <FormatNumber amount={-text} />;
                }
                if (amountB.lt(0))
                    return null;
                return <FormatNumber amount={text} />;
            },
        },
        {
            title: t`Created At`,
            dataIndex: 'created_at',
            key: 'created_at',
            width: DateTimeWidth,
            ellipsis: true,
            render: text => <CreatedAtTd text={text} />,
        },
    ];
}

export default {
    storageKey: StorageKey.bank_reconciliation_manual,
    required: [
        'number',
        'type',
        'date',
        'debit',
        'credit',
    ],
    defaulto: [
        'name',
        'number2',
        'description',
    ],
    getColumns,
};
